module.exports = __webpack_public_path__ + "img/anewitem-decors.52f290ec.svg";